
import { ChevronDownIcon, XCircleFillIcon } from '@primer/octicons-react';
import { Box, Button, Checkbox, FormControl, SelectPanel } from '@primer/react';
import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useCommonContext } from '../../contexts/common';
import { useCommonSelectedHook } from '../../hooks/useCommonSelectedHook';
import { noitru_phong_namhoc } from '../../models/response/category/noitru_phong_namhoc';
import { actions } from '../../state/actions/actionsWrapper';
import { RootState } from '../../state/reducers';
type IComboboxPhongNamHocProps = {
	isReadonly?: boolean;
	ignore_id?: number,
	value: number;
	onValueChanged: (id: number, lops?: noitru_phong_namhoc) => void;
	className?: string;
	preText?: string;
	width?: string | number;
	dm_khoi_id?: number;
	dm_truong_id?: number;
	dm_he_id?: number;
	nam_hoc?: string;
	stylingMode?: 'outlined' | 'filled' | 'underlined';
	isShowClearBtn?: boolean,
	maxWidth?: any
};
const ComboboxPhongNamHoc = (props: IComboboxPhongNamHocProps) => {
	const { translate } = useCommonContext();
	const { nam_hoc, dm_truong_id } = useCommonSelectedHook();
	const dispatch = useDispatch();
	const { status: phongNamHocStatus, noitru_phong_namhocs } = useSelector((x: RootState) => x.danhMucWrapper.phongNamHoc);

	useEffect(() => {
		dispatch(actions.danhMucWrapper.phongNamHoc.selectStart());
	}, [nam_hoc, dm_truong_id])


	const phongNamHocFilters: any[] = useMemo(() => {
		return noitru_phong_namhocs
			// && props.nam_hoc && props.dm_truong_id
			? noitru_phong_namhocs.filter(x => x.nam_hoc === nam_hoc).sort((a, b) => (a.ten_phong > b.ten_phong) ? 1 : -1)
			: [];
	}, [noitru_phong_namhocs]);
	const [filter, setFilter] = useState('')
	const [open, setOpen] = useState(false)
	const dataSource = useMemo(() => {
		return noitru_phong_namhocs
		.filter(x => x.nam_hoc === nam_hoc)
		.map(x => {
			const item: any = {
				id: x.id,
				text: x.ten_phong,
			}
			return item;
		})
	}, [phongNamHocFilters, filter])
	const filterdData = useMemo(() => {
		return dataSource.filter(item =>
			item.text.toLowerCase().includes(filter.toLowerCase())
		)
	}, [dataSource, filter])
	const _selectedData = useMemo(() => {
		return dataSource.find(item => props.value && props.value === item.id)
	}, [props.value, dataSource])
	return (
		<SelectPanel
			renderAnchor={({ children, 'aria-labelledby': ariaLabelledBy, ...anchorProps }) => (
				<Button
					trailingAction={ChevronDownIcon}
					aria-labelledby={`${ariaLabelledBy}`}
					{...anchorProps}
					sx={{
						width: props.width || '100%',
						'[data-component="buttonContent"]': {
							display: 'flex',
							justifyContent: 'flex-start',
							gridTemplateAreas: 'none',
							gridTemplateColumns: 'none',
							'& > :first-child': {
								flex: 1,
								textAlign: 'left'
							}
						}
					}}
				// disabled={props.isReadonly || !props.dm_toa}
				>
					{children || translate("Chọn phòng")}
				</Button>
			)}
			title=""
			placeholderText="Tìm kiếm phòng..."
			open={open}
			onOpenChange={setOpen}
			items={filterdData}
			selected={_selectedData}
			onSelectedChange={(selected: any) => {
				if (selected) 
					props.onValueChanged(selected.id, selected.data);
			}}
			onFilterChange={setFilter}
			showItemDividers={true}
			overlayProps={{ width: 'small', height: 'medium' }}
		/>
	);
};

export default ComboboxPhongNamHoc;
